import { Component, OnInit, Input, ContentChildren, QueryList } from '@angular/core';
import { CdAccordionPanelComponent } from '../cd-accordion-panel/cd-accordion-panel.component';
import { CdsIconConfig } from '@cds/ng-core/icon';
import { CdsProgressModule } from '@cds/ng-web-components/progress';
import { NoResultFoundComponent } from '../../../shared/no-result-found/no-result-found.component';

@Component({
  selector: 'app-cd-accordion',
  templateUrl: './cd-accordion.component.html',
  styleUrls: ['./cd-accordion.component.scss'],
  imports: [CdsProgressModule, NoResultFoundComponent],
})
export class CdAccordionComponent implements OnInit {
  @ContentChildren(CdAccordionPanelComponent)
  cols?: QueryList<CdAccordionPanelComponent>;
  @Input() noTopLine = false;
  @Input() noResultMsg?: string;
  @Input() progress = false;

  notfoundConfig: CdsIconConfig = { color: '#8e90a2', size: 'md' };

  constructor() {}

  ngOnInit(): void {}
}
